import Openable from 'utils/lib/openable';

class Modal extends Openable {
  constructor(element) {
    super(element);

    this.classes = {
      active: 'modal--active',
    };
  }
}

export default (element: string | HTMLElement): Modal => new Modal(element);
